// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageSelector_container__3malb","activate":"LanguageSelector_activate__11Cz4"};